/* eslint-disable */
import { Container, Grid } from '@material-ui/core'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { PageWrapper } from '../../components/atoms/PageWrapper'
import { SectionTitle } from '../../components/atoms/SectionTittle'
import { PuzzleCardView } from '../../components/molecules/PuzzleCardsView'
import { getPuzzles } from '../../services/puzzles-services'
import { useInvokeEffect } from '../../utils/helper'
import {PuzzleHeaderDto} from '../../utils/types'

export const Puzzles: React.FC = () => {
    const [puzzles, setPuzzles] = React.useState<PuzzleHeaderDto[]>([])
    const location = useLocation()
    
    // Extract the selected puzzle ID from URL params
    const urlParams = new URLSearchParams(location.search)
    const selectedPuzzleId = urlParams.get('selected')

    useInvokeEffect(async () => {
        const loadedPuzzles = await getPuzzles()
        setPuzzles(loadedPuzzles)
        
        // Auto-open the selected puzzle if specified in URL
        if (selectedPuzzleId) {
            // Small delay to ensure component is rendered
            setTimeout(() => {
                const selectedPuzzleElement = document.querySelector(`[data-puzzle-id="${selectedPuzzleId}"] button`)
                if (selectedPuzzleElement) {
                    (selectedPuzzleElement as HTMLButtonElement).click()
                }
            }, 100)
        }
    }, [], {
        operation: 'Liste Opgaver',
    })

    return (
        <PageWrapper>
            <SectionTitle text="Opgaver"/>
            <Container>
                <Grid container>
                    {puzzles.map((pz) => {
                        return (
                            <Grid spacing={1} item xs={12} md={6} lg={4} key={pz.puzzleId}>
                                <div data-puzzle-id={pz.puzzleId}>
                                    <PuzzleCardView
                                        puzzle={pz}
                                    />
                                </div>
                            </Grid>
                        )
                    })}
                </Grid>
            </Container>
        </PageWrapper>

    )
}
